<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>子商户报备查询</h1>
        <p>查询子商户微信支付宝认证状态</p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM7604</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的行方全局唯一的商户编号</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String(15)</td><td>是</td><td>固定：mcht</td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String(32)</td><td>是</td><td>固定：1</td></tr>
         </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>产品列表</td><td>productList</td><td>String（512）</td><td>是</td><td></td></tr>
          <tr><td>产品码</td><td>- productCode</td><td>String（64）</td><td>是</td><td>WXPAY：微信；ALIPAY：支付宝</td></tr>
          <tr><td>报备状态</td><td>- productStatus</td><td>String（64）</td><td>是</td><td>
            B106007 开通成功<br>
            B106008 开通失败<br>
            B106009 开通中<br>
            B106043 已冻结<br>
            B106044 实名审核驳回<br>
            B106045 待确认联系信息<br>
            B106046 已作废<br>
            B106047 待账户验证<br>
            B106048 实名审核中<br>
            B106049 实名审核通过<br>
            B106065 待法人确认
            </td></tr>
          <tr><td>审核原因</td><td>- rejectReason</td><td>String（64）</td><td>否</td><td></td></tr>
          <tr><td>二维码链接</td><td>- qrCodeData</td><td>String（64）</td><td>否</td><td></td></tr>
          <tr><td>第三方商户号</td><td>- productChannelMerchantNo</td><td>String（64）</td><td>否</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'App',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshcx', 'name': '子商户开通查询'},
        {'url': '/interface/zshbbcx', 'name': '子商户报备查询'},
        {'url': '/interface/zshfzxy', 'name': '子商户分账协议签署'},
        {'url': '/interface/zshpz', 'name': '子商户业务配置'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Zshbbcx.vue